import axios from 'axios';

/**
 * Moving to Axios API since used across verticals
 */
export default class FetchHelper {
  /**
   * Returns a promise using axios
   * @param {*} method
   * @param {*} params
   */
  request(method, params) {
    let apiHeaders = {
      'Content-Type': (params.isJson)
        ? 'application/json'
        :'application/x-www-form-urlencoded;charset=UTF-8'
    };
    params.params = params.params || {};
    if (params.cookies) {
      params.params['cookies'] = params.cookies;
    }

    let options = {
      method: method ? method : 'GET',
      url: params.url,
      headers: apiHeaders,
      params: params.params,
      withCredentials: (params.includeCredentials)
        ? params.includeCredentials
        : false
    };

    if (params.data){
      options.data = params.data;
    }

    if (params.excludeHeader){
      delete(options.headers);
    }

    return this.apiCall(options);
  }

  /**
   * @param {*} options
   */
  apiCall(options) {
    return axios(options);
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/FetchHelper/index.js